import { createFileRoute } from '@tanstack/react-router';
import { DebtorsListPage } from '@/features/debts/debtors-list-page.js';

export const Route = createFileRoute('/_app/accounts/')({
  component: DebtorsListPage,
});
